import { Record, Map } from 'immutable';
import ActivityType from './activityType';

const ActivityRecord = Record({
  id: undefined,
  activityType: ActivityType,
  calories: undefined,
  distance: undefined,
  duration: undefined,
  felt: undefined,
  intensity: undefined,
  completedAt: undefined,
  _links: new Map(),
  _forms: new Map()
});

class Activity extends ActivityRecord {

  constructor(props) {
    props.activityType = new ActivityType(props.activityType);

    super(props);
  }

  getLink(linkName) {
    return this._links[linkName];
  }

  getForm(formName) {
    return this._forms[formName];
  }

}

export default Activity;


// WEBPACK FOOTER //
// ./src/api/models/activity.js